var exports = {
  "rf": "VoiceMessageComposerModal.module__body___R1dBX1",
  "BK": "VoiceMessageComposerModal.module__helpText___R1dBX1",
  "kc": "VoiceMessageComposerModal.module__errorText___R1dBX1",
  "mI": "VoiceMessageComposerModal.module__meta___R1dBX1",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___R1dBX1",
  "ne": "VoiceMessageComposerModal.module__controls___R1dBX1",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___R1dBX1",
};

module.exports = exports;
